import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Card, Col, Row, Table, Button, Modal } from "antd";
import {
  deleteDelegate,
  getDelegatesList,
  updateDelegate, 
} from "../../../redux/slices/delegates/delegatesThunk";
import { PlusOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import AssignProductsModal from "../AssignProductsModal";
import AssignSamplesModal from "../AssignSamplesModal";
import AssignSpecificSamplesModal from "../AssignSpecificSamplesModal";

import { columns } from "./columns"; 

const DelegatesPage = () => {
  const [filter] = useState({ search: "" });
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [itemIdToDelete, setItemIdToDelete] = useState(null);
  const [pagination, setPagination] = useState({ currentPage: 1, pageSize: 10 });
  const [isProductsModalVisible, setIsProductsModalVisible] = useState(false);
  const [isSamplesModalVisible, setIsSamplesModalVisible] = useState(false);
  const [isSpecificModalVisible, setIsSpecificModalVisible] = useState(false);
  const [selectedDelegate, setSelectedDelegate] = useState(null);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(getDelegatesList({ page: pagination.currentPage, itemsPerPage: pagination.pageSize, filter }));
  }, [dispatch, pagination, filter]);

  const delegatesData = useSelector((state) => state.delegates.delegatesList?.data?.data);
  const delegatesData_loding = useSelector((state) => state.delegates.delegatesList?.loading);
  const totalItems = useSelector((state) => state.delegates.delegatesList?.data?.total);

  const showDeleteModal = (id) => {
    setIsDeleteModalOpen(true);
    setItemIdToDelete(id);
  };

  const handleDelete = (id) => {
    dispatch(deleteDelegate(id)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(getDelegatesList({ page: pagination.currentPage, itemsPerPage: pagination.pageSize, filter }));
        toast.success("Délégué supprimé avec succès.");
      } else {
        toast.error("Erreur lors de la suppression du délégué.");
      }
    });
    setIsDeleteModalOpen(false);
  };

  // --- FONCTION CORRIGÉE POUR LE SWITCH ---
  const handleToggleDashboardStats = (record) => {
      const newValue = !record.excludeFromStats;
      
      // On prépare l'objet pour correspondre exactement au DTO attendu par le Backend
      const userData = { 
          firstname: record.firstname,
          lastname: record.lastname,
          email: record.user?.email || record.email, // Récupère l'email depuis l'objet user lié
          phoneNumber: record.phoneNumber,
          address: record.address,
          excludeFromStats: newValue 
      };

      dispatch(updateDelegate({
          userId: record.id,
          userData: userData,
      })).then((res) => {
          if (res.meta.requestStatus === "fulfilled") {
              toast.success(`Délégué ${record.lastname} ${newValue ? 'exclu' : 'réintégré'}`);
              // Rafraîchir la liste pour mettre à jour l'état du Switch
              dispatch(getDelegatesList({ page: pagination.currentPage, itemsPerPage: pagination.pageSize, filter }));
          } else {
              toast.error("Échec de la mise à jour (Vérifiez le DTO Backend)");
          }
      });
  };

  const handleCategoryChange = (record, newCategory) => {
      const userData = { 
          firstname: record.firstname,
          lastname: record.lastname,
          email: record.user?.email || record.email,
          phoneNumber: record.phoneNumber,
          address: record.address,
          excludeFromStats: record.excludeFromStats,
          category: newCategory || null // Envoie la nouvelle catégorie sélectionnée
      };

      dispatch(updateDelegate({
          userId: record.id,
          userData: userData,
      })).then((res) => {
          if (res.meta.requestStatus === "fulfilled") {
              toast.success(`Gamme mise à jour pour ${record.lastname} : ${newCategory || 'Aucune'}`);
              dispatch(getDelegatesList({ page: pagination.currentPage, itemsPerPage: pagination.pageSize, filter }));
          } else {
              toast.error("Échec de la mise à jour de la catégorie.");
          }
      });
  };

  const naviagteTo = (path) => {
    history.push(path);
  };

  const handlePageChange = (page, pageSize) => {
    setPagination({ pageSize: pageSize, currentPage: page });
  };

  const openAssignModal = (delegate, type) => {
    setSelectedDelegate(delegate);
    if (type === 'products') {
        setIsProductsModalVisible(true);
    } else if (type === 'samples') {
        setIsSamplesModalVisible(true);
    } else if (type === 'specific') {
        setIsSpecificModalVisible(true);
    }
  };

  const closeAssignModals = () => {
    setSelectedDelegate(null);
    setIsProductsModalVisible(false);
    setIsSamplesModalVisible(false);
    setIsSpecificModalVisible(false);
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Liste des délégués"
            extra={<Button type="primary" onClick={() => naviagteTo("/nouveau/délégués")}><PlusOutlined /> Ajouter un délégué</Button>}
          />
          <Card bordered={false} className="criclebox tablespace mb-24">
            <Table
              // handleToggleDashboardStats est bien passé ici
              columns={columns(openAssignModal, naviagteTo, showDeleteModal, handleToggleDashboardStats, handleCategoryChange)}
              dataSource={delegatesData}
              className="ant-border-space"
              rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
              scroll={{ x: 1300 }}
              rowKey={(record) => record.id}
              pagination={{
                current: pagination.currentPage,
                pageSize: pagination.pageSize,
                total: totalItems,
                onChange: handlePageChange,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50"],
                position: ["topRight", "bottomRight"],
              }}
              loading={delegatesData_loding}
            />
          </Card>
        </Col>
        <Modal
          title="Supprimer un délégué"
          open={isDeleteModalOpen}
          onCancel={() => setIsDeleteModalOpen(false)}
          onOk={() => handleDelete(itemIdToDelete)}
          okText="Supprimer"
          cancelText="Annuler"
          okButtonProps={{ danger: true }}
        >
          <p>Êtes-vous sûr de vouloir supprimer ce délégué ? </p>
        </Modal>

        {selectedDelegate && (
            <>
                <AssignProductsModal visible={isProductsModalVisible} onCancel={closeAssignModals} delegate={selectedDelegate} />
                <AssignSamplesModal visible={isSamplesModalVisible} onCancel={closeAssignModals} delegate={selectedDelegate} />
                <AssignSpecificSamplesModal visible={isSpecificModalVisible} onCancel={closeAssignModals} delegate={selectedDelegate} />
            </>
        )}
      </Row>
    </div>
  );
};

export default DelegatesPage;